import list_icon from '@/assets/img/device/mg68/list_icon_pro_max.png'
import { Mg68 } from './mg68'

export class Mg68Pro extends Mg68 {
  name: string = 'MG68_Pro'
  icon: string = list_icon
  width: number = 710
}
